import axios from './axios';

import { Partner, PartnerPayload, PartnersParams, PartnersResponse } from '../types/partner';

const ADMIN_BASE = '/admins/partners/';

// A staged file forces multipart, and the axios interceptor leaves FormData
// bodies untouched — so these keys are written in snake_case by hand.
function buildPayload(payload: PartnerPayload): PartnerPayload | FormData {
  if (!payload.logo) return payload;

  const data = new FormData();
  data.append('referral_id', payload.referralId);
  data.append('name', payload.name ?? '');
  data.append('logo', payload.logo, payload.logo.name);
  return data;
}

export async function getPartners(params: PartnersParams): Promise<PartnersResponse> {
  return axios
    .get(ADMIN_BASE, {
      params: {
        // The table is 0-indexed, the backend paginator is 1-indexed.
        page: params.page + 1,
        pageSize: params.pageSize,
        search: params.search,
      },
    })
    .then(({ data }) => data);
}

export async function createPartner(payload: PartnerPayload): Promise<Partner> {
  return axios.post(ADMIN_BASE, buildPayload(payload)).then(({ data }) => data);
}

export async function updatePartner(partnerId: number, payload: PartnerPayload): Promise<Partner> {
  return axios.patch(`${ADMIN_BASE}${partnerId}/`, buildPayload(payload)).then(({ data }) => data);
}

// Public: the signup page is anonymous, so this runs without an auth header.
export async function getPartnerByReferralId(referralId: string): Promise<Partner> {
  return axios.get(`/partners/${encodeURIComponent(referralId)}/`).then(({ data }) => data);
}
